import type { SbEditableComponentProps } from "types/storyblok";
import { logos } from "./Logo.config";
import type { LogoProps } from "./Logo.d";

const Logo = ({ logo, logoWidth, color, sbEditable }: SbEditableComponentProps<LogoProps>) => {
  const Component = logos[logo];
  return <Component color={color} w={`${logoWidth}px`} h="auto" {...sbEditable} />;
};

export default Logo;
